import { createFileRoute } from '@tanstack/react-router';
import { JourneysIntegrationsHandoff } from '@/pages/workspaces/integrations/routing';

function JourneysIntegrationsDevelopersRoute() {
  return <JourneysIntegrationsHandoff target="developers" />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/integrations/all/developers')({
  component: JourneysIntegrationsDevelopersRoute,
});
